import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-styled-flexboxgrid';
import styled from 'styled-components';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import { TextField, Button } from '../../../../../components/molecules';

const StyledRow = styled(Row)`
  margin-bottom: 5px;
`;

const StyledForm = styled.form`
  flex-grow: 1;
  width: 100%;
`;

const StyledButton = styled(Button)`
  label {
    font-weight: 600;
    color: var(--gray-40) !important;
  }
`;

const StyledTextField = styled(TextField)`
  padding-bottom: 35px;
`;

const schema = yup.object({
  name: yup.string().required("What's your organization name?")
});

const OrganizationDetailsForm = ({
  onSubmit,
  onSkip = null,
  close = null,
  defaultValues = {
    name: '',
    displayName: '',
    category: '',
    legalId: ''
  },
  submitFormLabel = 'Create Organization',
  className = null
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting }
  } = useForm({ resolver: yupResolver(schema), defaultValues });

  const nameInput = register('name');

  return (
    <StyledForm onSubmit={handleSubmit(onSubmit(close))} noValidate className={className}>
      <StyledRow>
        <Col xs={12}>
          <StyledTextField
            label='Legal name'
            placeholder='Company Name'
            name={nameInput.name}
            onChange={nameInput.onChange}
            onBlur={nameInput.onBlur}
            ref={nameInput.ref}
            error={errors.name?.message}
          />
        </Col>
      </StyledRow>

      <StyledRow>
        <Col
          xs={12}
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            columnGap: '10px',
            alignItems: 'center'
          }}
        >
          {onSkip && (
            <StyledButton naked onClick={onSkip}>
              Skip for now
            </StyledButton>
          )}
          {/* Temporary disable save button until we implement update organization */}
          <Button isSubmitting={isSubmitting} disabled={defaultValues.name !== ''} secondary>
            {submitFormLabel}
          </Button>
        </Col>
      </StyledRow>
    </StyledForm>
  );
};

OrganizationDetailsForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onSkip: PropTypes.func,
  close: PropTypes.func,
  submitFormLabel: PropTypes.string,
  className: PropTypes.string,
  defaultValues: PropTypes.shape({
    name: PropTypes.string,
    displayName: PropTypes.string,
    category: PropTypes.string,
    legalId: PropTypes.string
  })
};

export { OrganizationDetailsForm };
